import { render, staticRenderFns } from "./ItemPrice.vue?vue&type=template&id=2b39ad52&"
import script from "./ItemPrice.vue?vue&type=script&lang=js&"
export * from "./ItemPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports